import { AuthoringSystem } from "@org-avp/avp-avengers-ui-framework-electron-api";
import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { GetStateFn } from "../utils/dispatchUtils";

export const authoringSystemSliceName = "authoringSystem";

export interface AuthoringSystemState {
  authoringSystem: AuthoringSystem;
}

const persistedAuthoringSystemState = localStorage.getItem(authoringSystemSliceName);
const persistedState = persistedAuthoringSystemState ? JSON.parse(persistedAuthoringSystemState) : null;
const initialState: AuthoringSystemState = persistedState ?? {
  authoringSystem: AuthoringSystem.DELTAGEN,
};

const authoringSystemSlice = createSlice({
  name: authoringSystemSliceName,
  initialState,
  reducers: {
    setAuthoringSystem(state: AuthoringSystemState, action: PayloadAction<AuthoringSystem>) {
      state.authoringSystem = action.payload;
      return state;
    },
  },
});

export type AuthoringSystemRootState = { [authoringSystemSliceName]: AuthoringSystemState };
export const selectAuthoringSystem = (state: AuthoringSystemRootState) => state[authoringSystemSliceName];
export const setAuthoringSystem = (authoringSystem: AuthoringSystem) => (dispatch: Dispatch, getState: GetStateFn) => {
  dispatch(authoringSystemSlice.actions.setAuthoringSystem(authoringSystem));
  localStorage.setItem(authoringSystemSliceName, JSON.stringify(
    selectAuthoringSystem(getState()),
  ));
};

export const authoringSystemReducer = authoringSystemSlice.reducer;
